<template>
    <el-scrollbar>
        <div class="house_wrap">
            <div class="house_main">
                <div class="main_one">
                    <!-- <h3 class="add_room">新增房间</h3> -->
                    <div class="house_cont">
                        <div class="house_cont_left">
                            <h4>
                                <i style="color:#F56C6C;padding-right:6px;">*</i>房间号
                            </h4>
                            <el-input v-model="roomNumber" placeholder="请输入内容" class="house_num"></el-input>
                            <!-- <h4>是否临街</h4> -->
                            <!-- <div class="YN house_num">
                                <el-radio
                                    v-model="frontage"
                                    label="YES"
                                    border
                                    size="mini"
                                    style="width:45px;height:30px;margin-right:10px;"
                                    class="btn"
                                >是</el-radio>
                                <el-radio
                                    v-model="frontage"
                                    label="NO"
                                    border
                                    size="mini"
                                    style="width:45px;height:30px;"
                                    class="btn"
                                >否</el-radio>
                            </div>-->
                            <div style="display:flex;align-items:top">
                                <div>
                                    <span>是否临街</span>
                                    <el-select style="margin-top: 10px;" class="uiint_info_unit" v-model="frontage"
                                               placeholder="请选择">
                                        <el-option label="是" value="YES"></el-option>
                                        <el-option label="否" value="NO"></el-option>
                                    </el-select>
                                </div>
                                <div style="min-width:120px;">
                                    <span>
                                        <i style="color:#F56C6C;padding-right:6px;">*</i>顺序
                                    </span>
                                    <el-input type="number" min="1" style="margin-top:10px" v-model="sort"
                                              placeholder="请输入正整数" class="house_num"></el-input>
                                </div>
                            </div>

                            <div>
                                <span>用途</span>
                                <el-select style="margin-top: 10px;" class="uiint_info_unit" v-model="purpose"
                                           placeholder="请选择" @visible-change="getUseData">
                                    <el-option v-for="(item,index) in useData" :key="index" :label="item.valueDesc"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="house_cont_right">
                            <el-button type="primary" @click="addpicShow" class="btn_selecthouse">选择户型</el-button>
                            <div class="maskhouseBox" @click="imgListShow = true">
                                <img v-if="houseData.images&&houseDataSta" @click="imgMaskShow(houseData.images)"
                                     :src="'http://'+houseData.images" alt />
                            </div>
                            <el-dialog title="请选择户型" :visible.sync="addpic"  width="980px" append-to-body>
                                <div class="dict_search_select">
                                    <div class="dict_select_item">
                                        <span class="year">建筑面积：</span>
                                        <el-input v-model="params.areaOfBuilding" placeholder="请输入建筑面积"></el-input>
                                    </div>
                                </div>
                                <div class="maskhouseBox" v-for="(item,index) in doorModelData"
                                     :class="borderActive==index?'borderActive':''" :key="index"
                                     @click="checkHousetype(item,index)">
                                    <img :src="'http://'+item.images" alt />
                                    <div class="content_btom">
                                        <div class="title">
                                            {{item.roomNumber}}室{{item.officeNumber}}厅{{item.toiletNumber}}卫{{item.balconyNumber}}阳
                                        </div>
                                        <div class="txt">建筑面积：{{item.areaOfBuilding}}m²</div>
                                        <div class="txt">套内面积：{{item.areaOfUse}}m²</div>
                                        <div class="txt">
                                            分摊面积：{{item.areaOfBuilding&&item.areaOfUse?(item.areaOfBuilding-item.areaOfUse).toFixed(4):'分摊面积'}}m²
                                        </div>
                                        <div class="txt">朝向：{{item.curOrientation}}</div>
                                    </div>
                                </div>

                                <div class="footer_page">
                                    <p class="data_number" style="line-height:32px">
                                        共
                                        <span>{{total}}</span>条
                                    </p>
                                    <el-pagination background layout="prev, pager, next" :total="total"
                                                   :page-size="PageSize" @current-change="handleCurrentChange"></el-pagination>
                                </div>
                                <span slot="footer" class="dialog-footer">
                                    <el-button @click="params.areaOfBuilding='',addpic = false">取 消</el-button>
                                    <el-button v-points type="primary" @click="params.areaOfBuilding='',addpic = false">确 定</el-button>
                                </span>
                            </el-dialog>

                            <div class="maskhouseBox" style="margin:0;">
                                <div class="content_btom">
                                    <div v-if="houseData.images&&houseDataSta">
                                        <div class="title">
                                            {{houseData.roomNumber}}室{{houseData.officeNumber}}厅{{houseData.toiletNumber}}卫{{houseData.balconyNumber}}阳
                                        </div>
                                        <div class="txt">建筑面积：{{houseData.areaOfBuilding}}m²</div>
                                        <div class="txt">套内面积：{{houseData.areaOfUse}}m²</div>
                                        <div class="txt">
                                            分摊面积：{{houseData.areaOfBuilding&&houseData.areaOfUse?(houseData.areaOfBuilding-houseData.areaOfUse).toFixed(4):'分摊面积'}}m²
                                        </div>
                                        <div class="txt">朝向：{{houseData.curOrientation}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main_two">
                    <h3 class="sync_room">将以上信息同步到其它房间</h3>
                    <div class="house_num_lists">
                        <ul class="rental_info_unit">
                            <!-- <li style="margin-left: 20px;" v-if="!unitData.findBuildDetailCell">没有此栋楼的单元信息</li> -->
                            <li class="rental_info_unit_item" :class="{active:isActive2==item.unitId}"
                                v-for="(item,index) in unitData" :key="index"
                                @click="getFloorRoomNrumer(item.unitId,index)">
                                {{item.unitNumber}}</li>
                        </ul>
                        <ul class="list">
                            <li v-for="(item,index) in floorData" :key="index">
                                <div class="tier">{{item.floorName}}</div>
                                <div class="room_num" :class="{active:item.isActive}" v-for="(item,index) in item.rooms"
                                     :key="index" @click="changeRoom(item.roomId)">
                                    {{item.roomName}}
                                    <i class="duihao"></i>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer1">
                <div class="btn">
                    <el-button type="info" style="width:80px;" @click="cls">取消</el-button>
                    <el-button v-points type="primary"
                               style="background:#5E75E6;border:1px solid #5E75E6;width:80px;margin-left:20px;" @click="sub">确定
                    </el-button>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    /* eslint-disable */
    import { dicGet } from "@/api";
    import {
        tungQuery,
        tungunitQuery,
        tungAddroom,
        tungUpdateroom,
    } from "@/api/manageCenter";
    import { houseTypeQuery } from "@/api/houseManage";
    export default {
        props: [
            "curTungId",
            "curFloorId",
            "propRoomId",
            "propRoomNumber",
            "propFrontage",
            "prophouseTypeId",
            "curPurpose",
            "prosort",
            "houseDataSta",
        ], //栋座ID 楼层
        data() {
            return {
                params: {
                    areaOfBuilding: "",
                },
                total: 0,
                PageSize: 12,
                PageNumber: 0,
                addpic: false,
                imgListShow: false,
                tungId: "",
                residentialAreaId: "", //小区编号
                roomNumber: "", //房间号
                houseTypeId: "",
                sort: "", //顺序
                frontage: "NO", //是否临街
                unitData: [], //楼栋信息
                isActive2: "",
                useData: [], //用途列表
                purpose: "", //用途
                floorData: [], //楼层信息
                roomsId: [], //房间id
                roomId: "", //当前的房间id
                doorModelData: [], //户型图列表
                towardData: [], //户型列表
                borderActive: -1,
                houseData: {},
            };
        },
        mounted() {
            this.getInfo();
            this.gethouseTypeList();
            this.gethouseTypeListPage();
            this.getUseData();
            // this.getTowardData(true)
            //cosole.log(1111,this.propRoomId)

            //cosole.log(this.propRoomNumber)
            if (this.propRoomId) {
                this.roomId = this.propRoomId;
                this.roomNumber = this.propRoomNumber;
                this.houseTypeId = this.prophouseTypeId;
                this.purpose = this.curPurpose;
                this.sort = this.prosort;
                //cosole.log(221313213,this.propFrontage)
                if (this.propFrontage == "临街") {
                    this.frontage = "YES";
                } else {
                    this.frontage = "NO";
                }
            }
        },

        watch: {
            "params.areaOfBuilding": function () {
                this.PageNumber = 0
                this.gethouseTypeList()
            },
        },
        methods: {
            async addpicShow(){
                let a = await this.gethouseTypeList()

                console.log(123)
                this.addpic=true

            },
            // 选择户型
            checkHousetype(data, index) {
                this.params.areaOfBuilding = ''
                this.houseData = data;
                console.log(111111111111, this.houseData);
                this.borderActive = index;
                this.addpic = false;
                this.$emit("changehouseDataSta", true);
            },

            // 查询用途
            getUseData() {
                let params = {
                    code: "tungPurpose",
                };
                this.$post(dicGet, params).then((res) => {
                    if (res.success) {
                        //cosole.log(res)
                        this.useData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                        });
                    }
                });
            },

            // 获取户型列表
            gethouseTypeList() {
                let id = sessionStorage.getItem("residentialAreaId");
                let params = {
                    residentialAreaId: id,
                    "page.pageNumber": this.PageNumber,
                    "page.pageSize": this.PageSize,
                    areaOfBuilding: this.params.areaOfBuilding
                };
                // return this.$post(houseTypeQuery, params)
                this.$post(houseTypeQuery, params).then((res) => {
                    if (res.success) {
                        console.log(12)
                        this.total = res.total;
                        this.doorModelData = res.data;
                    }
                });
            },

            gethouseTypeListPage() {
                let id = sessionStorage.getItem("residentialAreaId");
                let params = {
                    residentialAreaId: id,
                };
                this.$post(houseTypeQuery, params).then((res) => {
                    if (res.success) {
                        // this.getTowardData(true);
                        if (this.propRoomId) {
                            //cosole.log(12312312312321312,this.houseTypeId)
                            res.data.map((item, index) => {
                                if (item.houseTypeId == this.houseTypeId) {
                                    this.houseData = item;
                                    console.log(22222222222222, this.houseData);
                                }
                            });
                        }
                    }
                });
            },

            // 获取朝向
            // getTowardData(val) {
            //     if (val) {
            //         let params = {
            //             code: "orientation"
            //         };
            //         this.$post(dicGet, params).then(res => {
            //             if (res.success) {
            //                 this.towardData = res.data;

            //                 this.doorModelData.map((house, index) => {
            //                     this.towardData.map((item, index) => {
            //                         if (item.value == house.orientation) {
            //                             house.curOrientation = item.valueDesc;
            //                         }
            //                         //cosole.log(house)
            //                     });
            //                 });
            //             } else {
            //                 this.$message({
            //                     message: res.msg,
            //                     type: "error"
            //                 });
            //             }
            //         });
            //     }
            // },

            //取消

            handleCurrentChange(val) {
                this.PageNumber = (val - 1) * this.PageSize;
                this.gethouseTypeList();
            },
            cls() {
                this.$emit("removeAddhouse");
            },
            //提交
            sub() {
                if (!this.roomNumber) {
                    this.$message.error("房间号不能为空");
                    return false;
                }
                if (!this.sort) {
                    this.$message.error("顺序不能为空");
                    return false;
                }
                if (!/(^[1-9]\d*$)/.test(this.sort)) {
                    this.$message.error("顺序应为正整数");
                    return false;
                }
                let params = {
                    roomsId: this.roomsId,
                    floorId: this.curFloorId,
                    roomNumber: this.roomNumber,
                    frontage: this.frontage,
                    roomId: this.roomId,
                    houseTypeId: this.houseData.houseTypeId,
                    purpose: this.purpose,
                    sort: this.sort,
                    residentialAreaId: sessionStorage.getItem("residentialAreaId"),
                };
                if (!this.propRoomId) {
                    this.$post(tungAddroom, params).then((res) => {
                        if (res.success) {
                            this.$message.success({
                                message: res.msg,
                                type: "success",
                                duration: 1000,
                            });
                            this.$emit("removeAddhouse");
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                                duration: 1000,
                            });
                        }
                    });
                } else {
                    this.$post(tungUpdateroom, params).then((res) => {
                        if (res.success) {
                            this.$message.success({
                                message: res.msg,
                                type: "success",
                                duration: 1000,
                            });
                            this.$emit("removeAddhouse");
                        } else {
                            this.$message({
                                message: res.msg,
                                type: "error",
                                duration: 1000,
                            });
                        }
                    });
                }
            },

            getInfo() {
                this.residentialAreaId = window.sessionStorage.getItem(
                    "residentialAreaId"
                );
                let params = {
                    residentialAreaId: this.residentialAreaId,
                };
                //查询楼栋
                this.$post(tungQuery, params).then((res) => {
                    if (res.success) {
                        let params = {
                            tungId: this.curTungId,
                        };
                        //查询单元
                        this.$post(tungunitQuery, params).then((res) => {
                            if (res.success) {
                                this.unitData = res.data.units;
                                this.getFloorRoomNrumer(
                                    res.data.units[0].unitId,
                                    0
                                );
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                });
                            }
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                        });
                    }
                });
            },
            // 查询楼层和楼层房号
            getFloorRoomNrumer(unitId, index) {
                this.isActive2 = unitId;
                this.floorData = this.unitData[index].floors;
                this.floorData.map((item, index) => {
                    item.isActive = false;
                    item.rooms.map((room, rindex) => {
                        room.isActive = false;
                    });
                });
            },
            //图片show
            imgMaskShow(imgurl) {
                this.$emit("imgshow", imgurl);
                console.log(222, imgurl);
            },
            //添加房间号
            changeRoom(id) {
                if (!id){
                    return
                }
                let issave = this.roomsId.indexOf(id);
                // console.log(issave,id);
                if (issave === -1) {
                    this.roomsId.push(id);
                } else {
                    this.roomsId.splice(issave, 1);
                }
                this.floorData.map((item, index) => {
                    item.rooms.map((room, rindex) => {
                        if (room.roomId == id) {
                            let sta = room.isActive;
                            delete room.isActive;
                            this.$set(room, "isActive", !sta);
                        }
                    });
                });
            },
        },


    };
</script>
<style lang="less">
    .el-radio.is-bordered.is-checked {
        border-color: #5e75e6;
    }
    .el-radio__input.is-checked + .el-radio__label {
        color: #5e75e6;
    }
    .el-dialog__wrapper {
        .dict_search_select {
            display: flex;
            padding: 10px 0;
            .dict_select_item {
                min-width: 130px;
                margin-left: 20px;
                height: 30px;
                display: flex;
                align-items: center;
                font-size: 12px;

                .year {
                    padding: 4px 8px;
                    min-width: 30px;
                    color: #666;
                }
                .el-select {
                    width: 80px;
                    .el-input__inner {
                        border: none;
                        padding: 0px;
                        padding-left: 10px;
                        height: 30px;
                        // background: #f5f5f5;
                        border: 1px solid #dbdbdb;
                        border-radius: 3px;
                        width: 80px;
                    }
                    .el-input__icon {
                        line-height: 30px !important;
                    }

                    .el-input__suffix {
                        right: 0;
                    }
                }

                .el-input {
                    width: 200px;
                    .el-input__inner {
                        border: none;
                        padding: 0px;
                        padding-left: 10px;
                        height: 30px;
                        // background: #f5f5f5;
                        border: 1px solid #dbdbdb;
                        border-radius: 3px;
                        // width: 0px;
                    }
                }

                &.item_years {
                    display: flex;
                    align-items: center;

                    .el-input {
                        width: 80px;
                        .el-input__inner {
                            padding: 0 5px;
                            border: none;
                            text-align: center;
                        }
                    }
                }

                &.item_price {
                    border-right: none;
                }
            }
        }
    }
    .house_cont_left {
        .el-radio {
            position: relative;
            &:after {
                content: "";
                display: block;
                height: 12px;
                width: 12px;
                background-image: url(@../../../../assets/Y.svg);
                background-size: 100%;
                position: absolute;
                right: 0;
                top: 0;
            }
            .el-radio__input {
                display: none;
            }
            .el-radio__label {
                padding-left: 5px;
                color: #999999;
            }

            &.is-checked {
                position: relative;
                &:after {
                    content: "";
                    display: block;
                    height: 12px;
                    width: 12px;
                    background-image: url(@../../../../assets/N.svg);
                    background-size: 100%;
                    position: absolute;
                    right: 0;
                    top: 0;
                }
            }
        }
    }
    .borderActive {
        border: 2px solid #5e75e6 !important;
    }
    .maskhouseBox {
        width: 210px;
        display: inline-block;
        margin-left: 20px;
        margin-bottom: 20px;
        border: 2px solid #eeeeee;
        min-height: 134px;

        .notice {
            font: 16px/134px "";
            color: #777;
            text-align: center;
        }
        img {
            width: 100%;
            height: 134px;
            border: none !important;
        }
        .content_btom {
            padding: 0 8px;
            background: #eee;
            height: 134px;
            .title {
                font-size: 16px;
                line-height: 40px;
            }
            .txt {
                font-size: 12px;
                line-height: 23px;
            }
        }
    }

    .house_cont_left {
        .el-input__inner {
            height: 30px;
        }
    }
    .rental_info_unit {
        margin-bottom: 80px;
        .rental_info_unit_item {
            background: #f5f5f5;
            color: #bbb;
            text-align: center;
            cursor: pointer;
            width: 76px;
            height: 80px;
            line-height: 80px;
            margin-bottom: 4px;

            &.active {
                width: 72px;
                color: #5e75e6;
                background: #f4f6ff;
                border-left: 4px solid #5e75e6;
            }
        }
    }
</style>
<style lang="less" scoped>
    .house_wrap {
        font-size: 14px;
        .footer_page {
            position: relative;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding-right: 30px;
            background: #f5f5f5;
            padding: 10px 30px;
            .data_number {
                font-size: 12px;
                margin-right: 10px;
                line-height: 32px;
            }
            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }

            // .el-icon-arrow-left:before {
            //   content: "上一页";
            //   padding: 0 20px;
            //   color: #cccccc;
            //   font-size: 12px;
            // }

            // .el-icon-arrow-right:before {
            //   content: "下一页";
            //   padding: 0 20px;
            //   color: #cccccc;
            //   font-size: 12px;
            // }
        }
        .house_main {
            width: 610px;
            margin: 40px 35px;
            .main_one {
                .add_room {
                    font-size: 20px;
                    color: #5e75e6;
                }
                .house_cont {
                    margin-top: 20px;
                    display: flex;
                    justify-content: space-between;
                    .house_cont_left {
                        width: 260px;

                        h4 {
                            margin-bottom: 9px;
                        }
                        .house_num {
                            margin-bottom: 30px;
                        }
                    }
                    .house_cont_right {
                        width: 420px;
                        height: 134px;
                        padding-top: 50px;
                        display: flex;
                        justify-content: space-between;
                        position: relative;
                        .btn_selecthouse {
                            position: absolute;
                            top: 0;
                            left: 20px;
                        }
                        .cont_left {
                            width: 50%;
                            height: 150px;
                            background: #5e75e6;
                        }
                        .cont_right {
                            width: 50%;
                            height: 150px;
                            background: #eee;
                        }
                    }
                }
            }
            .main_two {
                margin-top: 40px;

                .sync_room {
                    margin-top: 70px;
                    font-size: 20px;
                    color: #5e75e6;
                    margin-bottom: 10px;
                }
                .house_num_lists {
                    margin-bottom: 100px;
                    position: relative;
                    .list {
                        margin-bottom: 100px;
                        position: absolute;
                        top: 0px;
                        left: 140px;
                        li {
                            margin-bottom: 10px;
                            color: #333333;
                            position: relative;
                            display: flex;
                            div:last-child {
                                border-right: 1px solid #cccccc;
                            }
                            .tier {
                                display: inline-block;
                                width: 60px;
                                height: 50px;
                                text-align: center;
                                line-height: 50px;
                                border: 1px solid #cccccc;
                                border-right: none;
                            }
                            .room_num {
                                cursor: pointer;
                                display: inline-block;
                                width: 60px;
                                height: 50px;
                                text-align: center;
                                line-height: 50px;
                                border: 1px solid #cccccc;
                                border-right: none;
                                position: relative;
                                vertical-align: middle;
                                .duihao {
                                    width: 12px;
                                    height: 12px;
                                    background-image: url(@../../../../assets/Y.svg);
                                    background-size: 100%;
                                    position: absolute;
                                    right: 0;
                                    top: 0;
                                }
                                &.active {
                                    .duihao {
                                        width: 12px;
                                        height: 12px;
                                        background-image: url(@../../../../assets/N.svg);
                                        background-size: 100%;
                                        position: absolute;
                                        right: 0;
                                        top: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .footer1 {
            width: 100%;
            height: 80px;
            background: #f5f5f5;
            position: absolute;
            bottom: 0;
            overflow: hidden;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .btn {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding: 0 20px;
            }
        }
    }
</style>




